import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "PermissionTree",
  props: {
    resources: {
      type: Array,
      default: () => []
    },
    selectedPermissions: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 1
    }
  },
  emits: ["change", "cascadeChange"],
  setup(props, {
    emit
  }) {
    // 递归收集所有子权限ID
    const getAllChildrenIds = resource => {
      let ids = [];
      if (!resource.children || resource.children.length === 0) {
        return ids;
      }
      // 收集直接子级的ID
      resource.children.forEach(child => {
        ids.push(child.permissionId);
        // 递归收集孙子级的ID
        if (child.children && child.children.length > 0) {
          ids = ids.concat(getAllChildrenIds(child));
        }
      });
      return ids;
    };
    // 查找资源项
    const findResourceById = (id, resources) => {
      for (const resource of resources) {
        if (resource.permissionId === id) {
          return resource;
        }
        if (resource.children && resource.children.length > 0) {
          const found = findResourceById(id, resource.children);
          if (found) return found;
        }
      }
      return null;
    };
    // // 处理权限选择变化（带级联效果）
    // const handlePermissionChange = (permissionId: string | number, checked: boolean) => {
    //   // 查找当前资源项
    //   const allResources = props.resources || [];
    //   const currentResource = findResourceById(permissionId, allResources);
    //   if (!currentResource) {
    //     // 如果找不到资源项，只更新当前项
    //     emit("change", { permissionId, checked });
    //     return;
    //   }
    //   // 准备级联更新项
    //   const cascadeUpdates: CascadeUpdateItem[] = [
    //     { permissionId, checked }, // 当前项
    //   ];
    //   // 收集所有子权限ID并设置相同状态
    //   const childrenIds = getAllChildrenIds(currentResource);
    //   childrenIds.forEach((childId) => {
    //     cascadeUpdates.push({ permissionId: childId, checked });
    //   });
    //   // 发送级联更新事件
    //   emit("cascadeChange", cascadeUpdates);
    // };
    // 处理子组件的变化
    const onChildChange = data => {
      emit("change", data);
    };
    // 检查权限是否选中的方法（改进版）
    const isPermissionChecked = permissionId => {
      // 1. 检查自身是否直接被选中
      if (props.selectedPermissions[permissionId] === true) {
        return true;
      }
      // 2. 如果自身未被选中，检查是否所有子节点都被选中
      const resource = findResourceById(permissionId, props.resources || []);
      if (!resource || !resource.children || resource.children.length === 0) {
        return false;
      }
      // 获取所有子孙节点
      const allChildrenIds = getAllChildrenIds(resource);
      if (allChildrenIds.length === 0) return false;
      // 检查所有子孙节点是否都被选中
      const allChildrenSelected = allChildrenIds.every(id => props.selectedPermissions[id] === true);
      return allChildrenSelected;
    };
    // 检查权限是否为半选状态（优化版 - 考虑深层嵌套）
    const isPermissionIndeterminate = permissionId => {
      // 如果当前节点已选中，则不是半选状态
      if (props.selectedPermissions[permissionId] === true) {
        return false;
      }
      // 查找当前资源项
      const currentResource = findResourceById(permissionId, props.resources || []);
      // 如果没有子节点或找不到资源项，不可能是半选状态
      if (!currentResource || !currentResource.children || currentResource.children.length === 0) {
        return false;
      }
      // 获取所有子孙节点ID
      const allChildrenIds = getAllChildrenIds(currentResource);
      if (allChildrenIds.length === 0) return false;
      // 检查是否有子节点被选中
      const hasSelectedChildren = allChildrenIds.some(id => props.selectedPermissions[id] === true);
      // 检查是否所有子节点都被选中
      const allChildrenSelected = allChildrenIds.every(id => props.selectedPermissions[id] === true);
      // 如果有子节点被选中，但不是全部，或者子节点有半选状态，则是半选状态
      return hasSelectedChildren && !allChildrenSelected;
    };
    // 处理权限选择变化（带级联效果 - 优化版）
    const handlePermissionChange = (permissionId, checked) => {
      // 查找当前资源项
      const allResources = props.resources || [];
      const currentResource = findResourceById(permissionId, allResources);
      if (!currentResource) {
        // 如果找不到资源项，只更新当前项
        emit("change", {
          permissionId,
          checked
        });
        return;
      }
      // 准备级联更新项
      const cascadeUpdates = [{
        permissionId,
        checked
      } // 当前项
      ];
      // 收集所有子权限ID并设置相同状态
      const childrenIds = getAllChildrenIds(currentResource);
      childrenIds.forEach(childId => {
        cascadeUpdates.push({
          permissionId: childId,
          checked
        });
      });
      // 如果选中，并且这是子节点，可能需要设置父节点
      if (checked) {
        // 查找所有可能的父节点
        const parentNodes = findParentNodes(permissionId, allResources);
        parentNodes.forEach(parentId => {
          // 检查父节点的所有子节点是否都被选中
          const parent = findResourceById(parentId, allResources);
          if (parent && parent.children) {
            const allChildIds = parent.children.map(child => child.permissionId);
            // 检查除了当前要选中的子节点外，其他所有子节点是否都被选中
            const otherChildrenSelected = allChildIds.filter(id => id !== permissionId).every(id => {
              // 检查级联更新中是否包含此ID
              const inCascadeUpdates = cascadeUpdates.some(item => item.permissionId === id && item.checked);
              // 检查现有选中状态
              return inCascadeUpdates || props.selectedPermissions[id] === true;
            });
            // 如果所有子节点都将被选中，那么父节点也应该被选中
            if (otherChildrenSelected) {
              cascadeUpdates.push({
                permissionId: parentId,
                checked: true
              });
            }
          }
        });
      }
      // 发送级联更新事件
      emit("cascadeChange", cascadeUpdates);
    };
    // 查找节点的所有父节点
    const findParentNodes = (id, resources, path = []) => {
      for (const resource of resources) {
        if (resource.children && resource.children.length > 0) {
          // 检查直接子节点
          if (resource.children.some(child => child.permissionId === id)) {
            return [...path, resource.permissionId];
          }
          // 递归检查更深层子节点
          const newPath = [...path, resource.permissionId];
          const result = findParentNodes(id, resource.children, newPath);
          if (result.length > 0) {
            return result;
          }
        }
      }
      return [];
    };
    return {
      handlePermissionChange,
      onChildChange,
      isPermissionChecked,
      isPermissionIndeterminate
    };
  }
});